import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/PasswordInput";
import { BrandLogo } from "@/components/Brand";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center"><BrandLogo /></div>
        <div className="bg-white rounded-2xl p-8 border border-brand-gold/20 shadow-sm" data-testid="admin-login-card">
          <h1 className="font-serif text-3xl text-brand-navy">{t("nav.admin")} — {t("cta.login")}</h1>
          <p className="text-sm text-slate-600 mt-2">Ariaf Catering Yönetici Paneli</p>
          <form onSubmit={submit} className="mt-6 grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="e">Email</Label>
              <Input id="e" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="p">Password</Label>
              <PasswordInput id="p" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
            </div>
            {err && <div className="text-sm text-red-600" data-testid="admin-login-error">{err}</div>}
            <Button type="submit" disabled={loading} className="bg-brand-navy hover:bg-brand-navy-dark text-white rounded-full mt-2" data-testid="admin-login-submit">
              {loading ? "..." : t("cta.login")}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
